<template>
  <div class="card">
    <div class="card-body">
      <div class="font-weight-bold mb-3">
        Summary Insight
      </div>

      <div
        v-for="(item, i) in items"
        :key="i"
        class="insight-tile"
      >
        <div class="tile-top d-flex align-items-center">
          <div class="tile-icon">
            <i
              class="fa"
              :class="item.icon"
            />
          </div>
          <small class="tile-label text-muted ml-3">
            {{ item.label }}
          </small>
          <div class="tile-value ml-auto font-weight-bold">
            {{ item.value }}
          </div>
        </div>

        <div class="tile-divider" />

        <div class="tile-bottom d-flex align-items-center">
          <small
            class="tile-delta"
            :class="item.direction === 'up' ? 'tile-delta-up' : 'tile-delta-down'"
          >
            <i
              class="fa mr-1"
              :class="item.direction === 'up' ? 'fa-arrow-up' : 'fa-arrow-down'"
            />
            {{ item.delta }}
          </small>
          <small class="text-muted ml-auto">
            from last period
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      default: ''
    }
  },
  computed: {
    footerLabel () {
      const period = String(this.period || '').toLowerCase()
      return period === 'monthly' || period === 'month' ? 'from last month' : 'from last days'
    }
  }
}
</script>

<style scoped>
.insight-tile + .insight-tile {
  margin-top: 12px;
}

.insight-tile {
  border: 1px solid #dedede;
  border-radius: 12px;
  padding: 12px 12px;
}

.tile-icon {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dedede;
  border-radius: 10px;
  color: #18b2bd;
  display: flex;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.tile-value {
  font-size: 14px;
}

.tile-divider {
  background: #ededed;
  height: 1px;
  margin: 10px 0;
}

.tile-delta-up {
  color: #16a34a;
}

.tile-delta-down {
  color: #dc2626;
}
</style>
